module.exports = __webpack_public_path__ + "media/images/app/checkout/green-tick-ab86c7b86f16484d5badd1371099e173.svg";